<script>
import Multiselect from "vue-multiselect";
import Treeselect from "@riophae/vue-treeselect";

export default {
  name: "SearchCard",
  components: {
    Multiselect,
    Treeselect,
  },
  props: {
    value: {
      type: Object,
      required: true,

    },
    fields: {
      type: Array,
      default: () => [],
    },
    searchLabel: {
      type: String,
      default: "Tìm kiếm",
    },
    clearLabel: {
      type: String,
      default: "Làm mới",
    },
  },
  methods: {
    defaultNormalizer(node) {
      if (node.children == null || node.children == "null") {
        delete node.children;
      }
    },
  },
};
</script>

<template>
  <div class="search-filters-box">
    <!-- Căn lề dưới (align-items-end) giúp tất cả các ô nhập và nút bấm thẳng hàng chân đế với nhau -->
    <div class="row align-items-end">

      <!-- Vòng lặp kết xuất các trường lọc cấu hình động -->
      <div v-for="field in fields" :key="field.key" :class="field.col ? 'col-lg-' + field.col : 'col-lg-4'"
        class="mb-3">
        <label v-if="field.label" class="filter-label">
          {{ field.label }}
        </label>

        <!-- KẾT XUẤT TRƯỜNG DẠNG CHỮ (TEXT INPUT) -->
        <div v-if="field.type === 'text'" class="search-input-wrapper">
          <span v-if="field.icon !== false" class="isax isax-search-normal-1 search-input-icon"></span>
          <input v-model="value[field.key]" type="text" class="search-input-control"
            :class="{ 'ps-3': field.icon === false }" :placeholder="field.placeholder || 'Tìm kiếm...'"
            @keyup.enter="$emit('search')" />
        </div>

        <!-- KẾT XUẤT TRƯỜNG DẠNG SELECT ĐƠN -->
        <div v-else-if="field.type === 'select'">
          <select v-model="value[field.key]" class="form-control form-select search-input-control ps-3"
            @change="$emit('search')">
            <option :value="null">
              {{ field.placeholder || "--- Tất cả ---" }}
            </option>
            <option v-for="opt in field.options" :key="opt.value" :value="opt.value">
              {{ opt.label }}
            </option>
          </select>
        </div>

        <!-- KẾT XUẤT TRƯỜNG DẠNG MULTISELECT (CHỌN NHIỀU) -->
        <div v-else-if="field.type === 'multiselect'">
          <multiselect v-model="value[field.key]" :options="field.options || []" :multiple="true"
            :close-on-select="false" :clear-on-select="false" :preserve-search="true"
            :placeholder="field.placeholder || 'Chọn nhiều...'" label="label" track-by="value">
          </multiselect>
        </div>

        <!-- KẾT XUẤT TRƯỜNG DẠNG CÂY THƯ MỤC (TREESELECT) -->
        <div v-else-if="field.type === 'treeselect'">
          <treeselect v-model="value[field.key]" :options="field.options || []"
            :normalizer="field.normalizer || defaultNormalizer" :placeholder="field.placeholder || 'Chọn danh mục...'"
            :searchable="field.searchable !== false" :show-count="true" :default-expand-level="1">
            <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"
              :class="labelClassName">
              {{ node.label }}
              <span v-if="shouldShowCount" :class="countClassName">({{ count }})</span>
            </label>
          </treeselect>
        </div>

        <!-- KẾT XUẤT TRƯỜNG DẠNG NGÀY THÁNG (DATE) -->
        <div v-else-if="field.type === 'date'">
          <input v-model="value[field.key]" type="date" class="form-control search-input-control ps-3"
            @change="$emit('search')" />
        </div>
      </div>

      <!-- Kế thừa Slot cho phép chèn input tùy biến bổ sung ngoài config -->
      <slot></slot>

      <!-- Khối các nút hành động (Tìm kiếm & Làm mới) -->
      <div class="col-12 mb-3 d-flex justify-content-center">
        <div class="btn-actions-wrapper">
          <button @click="$emit('search')" class="btn-search-action">
            <span class="isax isax-search-normal-1 text-sm"></span>
            {{ searchLabel }}
          </button>
          <button @click="$emit('clear')" class="btn-reset-action">
            <span class="isax isax-rotate-left text-sm"></span>
            {{ clearLabel }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
/* ======================== BỘ LỌC TÌM KIẾM BENTO CARD STYLE ======================== */
.search-filters-box {
  padding: 24px;
  border-bottom: 1px solid rgba(187, 202, 186, 0.2);
  background: linear-gradient(135deg,
      rgba(46, 125, 50, 0.02) 0%,
      rgba(251, 140, 0, 0.02) 100%);
  border-radius: 12px 12px 0 0;
}

.filter-label {
  display: block;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: var(--color-public-text-body, #374151);
  margin-bottom: 8px;
}

.search-input-wrapper {
  position: relative;
}

.search-input-icon {
  position: absolute;
  left: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: rgba(55, 65, 81, 0.5);
  font-size: 18px;
}

.search-input-control {
  width: 100%;
  height: 38px;
  /* Chiều cao tiêu chuẩn đồng bộ 38px */
  padding: 8px 16px 8px 44px;
  border: 1px solid var(--outline-variant, #bfcaba);
  border-radius: 8px;
  background-color: #ffffff;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  color: var(--color-public-text-body, #374151);
  outline: none;
  transition: all 0.2s ease-in-out;
}

.search-input-control.ps-3 {
  padding-left: 16px !important;
}

.search-input-control:focus {
  border-color: var(--color-public-primary, #2e7d32);
  box-shadow: 0 0 0 3px rgba(46, 125, 50, 0.1);
}

select.search-input-control {
  appearance: none;
  background-image: url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24' fill='none' stroke='%23374151' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='6 9 12 15 18 9'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 12px center;
  background-size: 16px;
}

/* ======================== PHONG CÁCH CHO VUE-MULTISELECT & VUE-TREESELECT ======================== */
::v-deep .multiselect {
  min-height: 38px !important;
}

::v-deep .multiselect__tags {
  border: 1px solid var(--outline-variant, #bfcaba) !important;
  border-radius: 8px !important;
  min-height: 38px !important;
  padding: 6px 40px 0 12px !important;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
  background-color: #ffffff !important;
}

::v-deep .multiselect__select {
  height: 36px !important;
}

::v-deep .multiselect__placeholder {
  color: rgba(55, 65, 81, 0.5) !important;
  font-size: 14px !important;
  margin-bottom: 0 !important;
  padding-top: 2px !important;
}

::v-deep .multiselect__single {
  font-size: 14px !important;
  margin-bottom: 0 !important;
  padding-top: 2px !important;
}

::v-deep .multiselect__tag {
  background-color: var(--color-public-primary, #2e7d32) !important;
  color: #ffffff !important;
}

::v-deep .multiselect__tag-icon:hover {
  background-color: #f64242 !important;
  color: #ffffff !important;
}

::v-deep .vue-treeselect__control {
  border: 1px solid var(--outline-variant, #bfcaba) !important;
  border-radius: 8px !important;
  height: 38px !important;
  font-family: var(--font-body, "Inter"), sans-serif;
  font-size: 14px;
}

::v-deep .vue-treeselect__placeholder,
::v-deep .vue-treeselect__single-value {
  line-height: 36px !important;
  font-size: 1rem !important;
  color: var(--color-public-text-body, #374151) !important;
}

/* ======================== KHỐI HÀNH ĐỘNG TÌM KIẾM & LÀM MỚI ======================== */
.btn-actions-wrapper {
  width: 100%;
  max-width: 320px;
  display: flex;
  gap: 8px;
  /* Khoảng cách an toàn giữa 2 nút bấm */
}

.btn-search-action {
  flex: 1;
  height: 38px;
  /* Khớp chiều cao tuyệt đối với các ô lọc */
  padding: 0 20px;
  background-color: var(--color-public-primary, #2e7d32);
  color: #ffffff;
  border: none;
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 1rem;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}

.btn-search-action:hover {
  background-color: #1b5e20;
  box-shadow: 0 4px 10px rgba(46, 125, 50, 0.15);
  transform: translateY(-1px);
}

.btn-reset-action {
  flex: 1;
  height: 38px;
  /* Khớp chiều cao tuyệt đối với các ô lọc */
  padding: 0 20px;
  background-color: #ffffff;
  color: var(--color-public-text-body, #374151);
  border: 1px solid var(--outline-variant, #bfcaba);
  font-family: var(--font-heading, "Montserrat"), sans-serif;
  font-weight: 700;
  font-size: 1rem;
  border-radius: 8px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  cursor: pointer;
  transition: all 0.2s;
  outline: none;
}

.btn-reset-action:hover {
  background-color: var(--surface-container-low, #f1f5eb);
  color: var(--color-public-primary, #1b5e20);
  border-color: var(--color-public-primary, #2e7d32);
}
</style>